import React, { createContext, useContext, useEffect, useState } from "react";
import client, { setToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
  const refresh = async () => {
    if (!localStorage.getItem("psl_token")) { setUser(false); return; }
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  };
  useEffect(() => { refresh(); }, []);

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(false);
  };

  const onLoggedIn = (u, token) => { setToken(token); setUser(u); };

  return (
    <AuthCtx.Provider value={{ user, setUser, refresh, logout, onLoggedIn }}>
      {children}
    </AuthCtx.Provider>
  );
}
